module.exports = __webpack_public_path__ + "static/img/applicableScene8.7606b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene8.png
// module id = 9qwB
// module chunks = 0